/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from 'containers/App';
import * as serviceWorker from './serviceWorker';

import {Provider} from 'react-redux';

import {configureStore} from 'store/store';

import i18next from 'i18next';
import i18n_nl from './i18n/nl.json';
import packageJson from '../package.json';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';

// Configure store

const {store} = configureStore();
export {store};

// Dev stuff

const isDev = process.env.NODE_ENV === 'development';

console.log(`Wisbits Admin Panel`);
console.log(`Backend is: ${process.env.REACT_APP_API_URL}`);
console.log(`Version: ${process.env.REACT_APP_BUILD_SHA}`);

Sentry.init({
  environment: process.env.REACT_APP_ENVIRONMENT ?? 'development',
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: packageJson.version,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

// Initialise internalization and render the DOM

i18next
  .init({
    lng: 'nl',
    debug: isDev,
    resources: {
      nl: {
        translation: {
          ...i18n_nl,
        },
      },
    },
  })
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>,
      document.getElementById('root')
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
  });
